import { useState } from 'react';
import DashboardLayout from '@/components/feature/DashboardLayout';
import Tabs from '@/components/base/Tabs';
import LaundryRatingsTab from '@/pages/ratings/components/LaundryRatingsTab';
import DriversRatingsTab from '@/pages/ratings/components/DriversRatingsTab';
import StarsDisplay from '@/pages/ratings/components/StarsDisplay';
import { laundryRatings, driverRatings } from '@/mocks/ratings';

const TABS = [
  { id: 'laundry', label: 'تقييمات المغسلة' },
  { id: 'drivers', label: 'تقييمات المندوبين' },
];

export default function RatingsPage() {
  const [activeTab, setActiveTab] = useState('laundry');

  const totalLaundryRatings = laundryRatings.length;
  const avgLaundry =
    totalLaundryRatings > 0
      ? laundryRatings.reduce((acc, r) => acc + r.stars, 0) / totalLaundryRatings
      : 0;

  const totalDriverReviews = driverRatings.reduce((acc, d) => acc + d.totalRatings, 0);
  const avgDrivers =
    driverRatings.length > 0
      ? driverRatings.reduce((acc, d) => acc + d.averageStars, 0) / driverRatings.length
      : 0;

  return (
    <DashboardLayout title="التقييمات">
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between gap-3">
          <h2 className="font-bold text-[18px] text-foreground-950">التقييمات</h2>
          <span className="rounded-full bg-background-100 px-3 py-1 text-[12px] text-foreground-500">
            للعرض فقط — تُدار من قِبل الإدارة
          </span>
        </div>

        {/* KPI row */}
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {[
            {
              icon: 'ri-store-2-line',
              label: 'تقييم المغسلة',
              value: avgLaundry.toFixed(1),
              sub: `${totalLaundryRatings} تقييم`,
              bg: 'bg-accent-100',
              text: 'text-accent-700',
              showStars: true,
              stars: avgLaundry,
            },
            {
              icon: 'ri-thumb-up-line',
              label: 'تقييمات ممتازة (5★)',
              value: laundryRatings.filter((r) => r.stars === 5).length,
              sub: `${Math.round((laundryRatings.filter((r) => r.stars === 5).length / totalLaundryRatings) * 100)}٪ من الكل`,
              bg: 'bg-success-100',
              text: 'text-success-700',
              showStars: false,
              stars: 0,
            },
            {
              icon: 'ri-e-bike-2-line',
              label: 'متوسط تقييم المندوبين',
              value: avgDrivers.toFixed(1),
              sub: `${totalDriverReviews} تقييم`,
              bg: 'bg-secondary-100',
              text: 'text-secondary-700',
              showStars: true,
              stars: avgDrivers,
            },
            {
              icon: 'ri-team-line',
              label: 'عدد المندوبين المُقيَّمين',
              value: driverRatings.length,
              sub: 'مندوب تابع',
              bg: 'bg-primary-100',
              text: 'text-primary-700',
              showStars: false,
              stars: 0,
            },
          ].map((stat) => (
            <div
              key={stat.label}
              className="flex items-center gap-3 rounded-card border border-background-200 bg-white p-4 shadow-card"
            >
              <span
                className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-[10px] ${stat.bg} ${stat.text}`}
              >
                <i className={`${stat.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <div>
                <p className="text-[11px] text-foreground-400">{stat.label}</p>
                <p className="mt-0.5 text-[20px] font-bold text-foreground-950">{stat.value}</p>
                {stat.showStars ? (
                  <StarsDisplay value={stat.stars} size="sm" />
                ) : (
                  <p className="text-[11px] text-foreground-400">{stat.sub}</p>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Tabs + content */}
        <div className="rounded-card border border-background-200 bg-white shadow-card">
          <div className="px-2 pt-1">
            <Tabs tabs={TABS} active={activeTab} onChange={setActiveTab} />
          </div>
          <div className="p-5">
            {activeTab === 'laundry' && <LaundryRatingsTab />}
            {activeTab === 'drivers' && <DriversRatingsTab />}
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}